export default {"src":"/_next/static/media/avocados.02855afb.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};